import gql from 'graphql-tag';

export const SearchAccidentIssueDocument = gql`
  query SearchAccidentIssueDocument($input: AccidentIssueDocumentConnectionInput) {
    searchAccidentIssueDocument {
      accidentIssueDocumentConnection(input: $input) {
        totalCount
        edges {
          node {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            issueId
            filename
            fileLocation
            contentType
            fileSize
            md5
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
